import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/product/category')({
  loader: () => {
    return {
      crumb: 'Kategori',
    }
  },
})
